/* eslint-disable no-unused-vars */
/* eslint-disable prefer-template */
/* eslint-disable indent */
/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "react-tippy";
import {
  selectRetrofitConfiguration,
  selectFiltersInit,
  selectPossibleFiltersValues,
  clearBundlesToCompare,
  selectMotorSynchronizedFilters,
  showSnackbar,
  selectFiltersWrapperOpened,
  setFiltersWrapperOpened,
  setAxisFilters,
} from "../../../../Retrofit/store/slices/retrofit";
import LabelsPicker from "../../../../Common/components/Inputs/LabelsPicker/LabelsPicker/LabelsPicker";
import SelectionRange from "../../../../Common/components/Inputs/SelectionRange/SelectionRange";
import ToggleInput from "../../../../Common/components/Inputs/ToggleInput/ToggleInput";
import Spinner from "../../../../Common/components/Icons/Spinner/Spinner";
import t from "../../../../Common/utils/translation/translator";
import { tData } from "../../../../Common/utils/translation/dataUtils";
import MsxIcons from "../../../../Common/components/Icons/MsxIcons/MsxIcons";
import Button from "../../../../Common/components/Buttons/Button/Button";
import { selectConfigurationType } from "../../../../Common/store/slices/common";
import { selectIntegratedDrivesConfiguration } from "../../../../IntegratedDrives/store/slices/integrated_drives";
import { selectSelectedAxis } from "../../../../Cartesian/store/slices/cartesian";
import { useUpdateEffect } from "react-use";
import { syncDataElementWithSynchronizedFiltersElement } from "../../../utils/func.util";

const MotorFilters = ({ closeTab, filters, filterToDisplay, gearboxFiltersProp, axisId, refetchBundles, updateMotorFilters, isLoading,...props }) => {
  const possibleMotorFiltersValues = useSelector(selectPossibleFiltersValues)?.motor;
  const retrofitConfiguration = useSelector(selectRetrofitConfiguration);
  const integratedDrivesConfiguration = useSelector(selectIntegratedDrivesConfiguration);
  const configuration = integratedDrivesConfiguration || retrofitConfiguration;
  const configurationType = useSelector(selectConfigurationType);
  const synchronizedMotorFilters = useSelector(selectMotorSynchronizedFilters);
  const filtersInit = useSelector(selectFiltersInit);
  const filtersWrapperOpened = useSelector(selectFiltersWrapperOpened);
  const dispatch = useDispatch();

  const [gearboxFilters, setGearboxFilters] = useState(filters?.gearboxFilter);
  const [data, setData] = useState( {
    ...filters?.motorFilter,
    withGearbox: filters?.motorFilter?.withGearbox || gearboxFilters?.enabled
  });
  const [highlightErrors, setHighlightErrors] = useState(false);

  const isIntegratedDrivesConfiguration = integratedDrivesConfiguration !== null;

  const handleApplyFilters = () => {
    if (
      !data?.ipDegreeOfProtection ||
      data?.ipDegreeOfProtection?.length === 0 ||
      !data?.holdingBrake ||
      data?.holdingBrake?.length === 0
    ) {
      setHighlightErrors(true);
      dispatch(showSnackbar({ id: "MANDATORY_FIELDS" }));
      return;
    }

    // SHAFT END
    const shaftEndFormatted = [];
    data.shaftEnd.map((v) => {
      if (v === "Keyed shaft") {
        shaftEndFormatted.push("KEYED", "PARALLEL_KEY");
      }
      if (v === "Smooth shaft") {
        shaftEndFormatted.push("SMOOTH_SHAFT", "UNTAPPED");
      }
      if (v !== "Keyed shaft" && v !== "Smooth shaft") {
        shaftEndFormatted.push(v);
      }
      return -1;
    });

    // MOTOR ENCODER
    const motorEncoderFormatted = [];
    data.motorEncoder.map((v) => {
      if (v === "SingleTurn") {
        motorEncoderFormatted.push(
          "20_BITS_1_TURN_ABS_ENCODER",
          "SINGLE_TURN_SINCOS_HIPERFACE",
          "ABS_1_TURN_SINCOS_HIPERFACE",
          "ABS_SINGLE_TURN_HIPERFACE_DSL",
          "23_BTS_OPTIC_INCREMENTAL_NCODR"
        );
      }
      if (v === "MultiTurn") {
        motorEncoderFormatted.push(
          "20_BITS_MULTI_TURN_ABS_ENCODER",
          "MULTITURN_SINCOS_HIPERFACE",
          "ABS_MULTITURN_SINCOS_HIPERFACE",
          "ABS_MULTITURN_HIPERFACE_DSL",
          "23_BITS_OPTIC_MULTITURN_ENCDR",
          "17_BITS_MGNTC_MULTITURN_ENCDR"
        );
      }
      if (v !== "SingleTurn" && v !== "MultiTurn") {
        motorEncoderFormatted.push(v);
      }
      return -1;
    });

    // filters of the current axis
    const newFilters = {
      ...configuration.configData.axes.find((a) => a.id === axisId).configFilters,
      motorFilter: {
        ...data
      },
      gearboxFilter: {
        ...gearboxFilters,
        enabled: data.withGearbox
      }
      
    };;
    dispatch(setAxisFilters({ axisId, filters: newFilters }))
    dispatch(clearBundlesToCompare());
    refetchBundles();
    closeTab();
  };

  const getDisabledLabels = (feedbackTypes) => {
    const disabledLabels = [];
    if (
      !feedbackTypes.some((r) =>
        [
          "20_BITS_1_TURN_ABS_ENCODER",
          "SINGLE_TURN_SINCOS_HIPERFACE",
          "ABS_1_TURN_SINCOS_HIPERFACE",
          "ABS_SINGLE_TURN_HIPERFACE_DSL",
          "23_BTS_OPTIC_INCREMENTAL_NCODR"
        ].includes(r)
      )
    ) {
      disabledLabels.push("single_turn");
    }

    if (
      !feedbackTypes.some((r) =>
        [
          "20_BITS_MULTI_TURN_ABS_ENCODER",
          "MULTITURN_SINCOS_HIPERFACE",
          "ABS_MULTITURN_SINCOS_HIPERFACE",
          "ABS_MULTITURN_HIPERFACE_DSL",
          "23_BITS_OPTIC_MULTITURN_ENCDR",
          "17_BITS_MGNTC_MULTITURN_ENCDR"
        ].includes(r)
      )
    ) {
      disabledLabels.push("multi_turn");
    }
    return disabledLabels;
  };

  const getDisabledShaftEnd = (shaftEnd) => {
    const disabledLabels = [];

    if (!shaftEnd.some((r) => ["KEYED", "PARALLEL_KEY"].includes(r))) {
      disabledLabels.push("keyed");
    }

    if (!shaftEnd.some((r) => ["SMOOTH_SHAFT", "UNTAPPED"].includes(r))) {
      disabledLabels.push("smooth_shaft");
    }
    return disabledLabels;
  };

  const getDisabledConnectorType = (connectorType) => {
    const disabledLabels = [];

    if (!connectorType.some((r) => ["STRAIGHT_CONNECTOR", "STRAIGHT_CONNECTORS"].includes(r))) {
      disabledLabels.push("Straight");
    }

    if (!connectorType.some((r) => ["ROTATABLE_RIGHT-ANGLED_CONNS", "ROTATABLE_RH_ANGLED_CONNECTOR"].includes(r))) {
      disabledLabels.push("Angled");
    }

    if (!connectorType.some((r) => ["CABLE_WITH_STRIPPED_END"].includes(r))) {
      disabledLabels.push("Free Lead");
    }

    if (!connectorType.some((r) => ["MIL"].includes(r))) {
      disabledLabels.push("MIL");
    }

    if (!connectorType.some((r) => ["MALE_FEMALE"].includes(r))) {
      disabledLabels.push("male/female");
    }

    return disabledLabels;
  };


  const handleClearFilters = () => {
    setData({
      ...filtersInit.motorFilter,
      withGearbox: filters.motorFilter?.withGearbox,
    });
  };
  const groupMotorTypeValues = (values) => {
    // group SH3..P and SH3..M to SH3
    // don't group other values
    const groupedValues = [];
    values.forEach((value) => {
      switch (value) {
        case "SH3..P":
        case "SH3..M":
          groupedValues.push("SH3");
          break;

        default:
          groupedValues.push(value);
      }
    });
    return [...new Set(groupedValues)];
  };

  const gearboxToggle = (
    <div
      className={`flex justify-start items-center space-x-2 space-y-1
      ${
        (isLoading || !data || !synchronizedMotorFilters) && !isIntegratedDrivesConfiguration
          ? "opacity-50 pointer-events-none"
          : ""
      }
      `}
      {...props}
    >
      {!isIntegratedDrivesConfiguration && (
        <div>
          <Tooltip
            title={t("msizer.ui.tooltip.cannot_change_option")}
            position="right"
            duration={200}
            arrow
            size="small"
            theme="light"
          >
            <span className="cursor-pointer">
              <MsxIcons
                name="info-tooltip"
                size="nano"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              />
            </span>
          </Tooltip>
        </div>
      )}
      <ToggleInput
        idLabel="motor-with-gearbox"
        switchable={synchronizedMotorFilters || isIntegratedDrivesConfiguration}
        checked={filters?.motorFilter?.withGearbox || filters?.gearboxFilter?.enabled}
        loading={isLoading}
        minimal={filterToDisplay === "gearboxToggleMinimal"}
        onChange={(checked) => {
          setData({ ...data, withGearbox: checked });
          const newFilters = {
            ...filters,
            gearboxFilter: {
              ...gearboxFilters,
              enabled: checked
            },
            motorFilter: {
              ...filters.motorFilter,
              withGearbox: checked
            }
          };
          dispatch(setAxisFilters({ axisId, filters: newFilters }));
          updateMotorFilters(newFilters.gearboxFilter);
          // onApplyFilters(axisId, newFilters);
          // handleToggleInputChange(checked);
          setTimeout(() => {
            if (checked && filtersWrapperOpened !== "GEARBOX") {
              dispatch(setFiltersWrapperOpened("GEARBOX"));
            }
            if (!checked && filtersWrapperOpened === "GEARBOX") {
              dispatch(setFiltersWrapperOpened(null));
            }
          }, 10);
        }}
        label={t("msizer.ui.motor_filters.motor_with_gearbox")}
      />
    </div>
  );

  if (filterToDisplay === "gearboxToggle" || filterToDisplay === "gearboxToggleMinimal") {
    return gearboxToggle;
  }

  const getMinMotorFlangeSize = () => {
      return synchronizedMotorFilters?.flangeSize?.min || possibleMotorFiltersValues?.flangeSize?.min;
  }

  const getMaxMotorFlangeSize = () => {
      return synchronizedMotorFilters?.flangeSize?.max || possibleMotorFiltersValues?.flangeSize?.max;
  }

  useEffect(() => {
    if (gearboxFiltersProp) {
      setGearboxFilters(gearboxFiltersProp);
    }
  }, [gearboxFiltersProp]);

  useUpdateEffect(() => {
    console.log("MotorFilters data changed", data);
    console.log("Synchronized motor filters", synchronizedMotorFilters);
    if (data && !isIntegratedDrivesConfiguration) {
      // wait until isSynchronizingAppDataFilters is false to run execSyncFilters
      if(!isIntegratedDrivesConfiguration) { 
        updateMotorFilters(data);

        const newFilters = {
          ...configuration.configData.axes.find((a) => a.id === axisId)?.configFilters,
          motorFilter: {
            ...data
          },
          gearboxFilter: {
            ...gearboxFilters,
            enabled: data.withGearbox
          } 
        };
       
        dispatch(setAxisFilters({ axisId, filters: newFilters }));
      }
    }
  }, [data]);

  return (
    <>
      <div className="MotorFilters relative" {...props}>
        <div
          className={`bg-gray-50 backdrop-blur-xs bg-opacity-50 h-full w-full top-0 left-0 absolute flex items-center justify-center z-20 ${
            !(isLoading || !data) && "hidden"
          }`}
        >
          <Spinner />
        </div>
        <div className="md:flex justify-end hidden">
          <span
            onClick={handleClearFilters}
            className="text-secondary text-sm px-2 py-1 cursor-pointer hover:underline select-none"
          >
            {t("msizer.ui.filters.clear")}
          </span>
        </div>
        <div className="md:flex space-x-2 divide-x-2 divide-gray-100 divide-solid">
          <div className="flex-1 p-2 space-y-4">
            <SelectionRange
              idLabel="nominal-torque"
              label={t("msizer.ui.motor_filters.nominal_torque_of_motor")}
              min={synchronizedMotorFilters?.nominalTorque?.min || possibleMotorFiltersValues?.nominalTorque?.min}
              max={synchronizedMotorFilters?.nominalTorque?.max || possibleMotorFiltersValues?.nominalTorque?.max}
              possibleMin={synchronizedMotorFilters?.nominalTorque?.min || possibleMotorFiltersValues?.nominalTorque?.min}
              possibleMax={synchronizedMotorFilters?.nominalTorque?.max || possibleMotorFiltersValues?.nominalTorque?.max}
              unit={t("msizer.ui.unit.nm")}
              step={0.05}
              currentMin={data?.nominalTorque?.min}
              currentMax={data?.nominalTorque?.max}
              onChange={(min, max) => {
                setData({ ...data, nominalTorque: { min, max } });
              }}
              changeWithInit
            />

            <SelectionRange
              idLabel="nominal-speed"
              label={t("msizer.ui.motor_filters.nominal_speed_of_motor")}
              min={synchronizedMotorFilters?.nominalSpeed?.min || possibleMotorFiltersValues?.nominalSpeed?.min}
              max={synchronizedMotorFilters?.nominalSpeed?.max || possibleMotorFiltersValues?.nominalSpeed?.max}
              possibleMin={synchronizedMotorFilters?.nominalSpeed?.min || possibleMotorFiltersValues?.nominalSpeed?.min}
              possibleMax={synchronizedMotorFilters?.nominalSpeed?.max || possibleMotorFiltersValues?.nominalSpeed?.max}
              unit={t("msizer.ui.unit.rpm")}
              currentMin={data?.nominalSpeed?.min}
              currentMax={data?.nominalSpeed?.max}
              onChange={(min, max) => {
                setData({ ...data, nominalSpeed: { min, max } });
              }}
              changeWithInit
            />

            <SelectionRange
              idLabel="flange-size"
              label={t("msizer.ui.motor_filters.flange_size")}
              min={getMinMotorFlangeSize()}
              max={getMaxMotorFlangeSize()}
              possibleMin={getMinMotorFlangeSize()}
              possibleMax={getMaxMotorFlangeSize()}
              unit={t("msizer.ui.unit.mm")}
              currentMin={data?.flangeSize?.min}
              currentMax={data?.flangeSize?.max}
              onChange={(min, max) => {
                setData({ ...data, flangeSize: { min, max } });
              }}
              changeWithInit
            />
          </div>
          <div className="flex-1 p-2 space-y-4">
            <LabelsPicker
              idLabel="ip-degree"
              label={t("msizer.ui.motor_filters.ip_degree_of_protection")}
              singleChoice
              required
              error={highlightErrors && (!data?.ipDegreeOfProtection || data?.ipDegreeOfProtection?.length === 0)}
              cols={3}
              options={[
                // loop over all possible IP degrees except null values
                ...possibleMotorFiltersValues?.ipDegreeOfProtection
                  .filter((d) => d !== null)
                  ?.sort()
                  .map((degree) => ({
                    label: tData("motor", "ip_degree_of_protection", degree),
                    key: degree
                  }))
              ]}
              selectedLabelsInit={data?.ipDegreeOfProtection}
              onChange={(val) => {
                setData({ ...data, ipDegreeOfProtection: val });
              }}
              disabledLabels={possibleMotorFiltersValues?.ipDegreeOfProtection.filter(
                (val) => !synchronizedMotorFilters?.ipProtection?.map((ip)=> ip.split(" ")[0]).includes(val) || !synchronizedMotorFilters
              )}
              changeWithInit
            />
            <LabelsPicker
              idLabel="motor-type"
              label={t("msizer.ui.motor_filters.motor_type")}
              singleChoice
              error={highlightErrors && (!data?.motorType || data?.motorType?.length === 0)}
              cols={3}
              options={[
                ...groupMotorTypeValues(possibleMotorFiltersValues?.motorType || [])
                  .filter((d) => d !== null)
                  ?.sort()
                  .map((type) => ({
                    label: tData("motor", "motor_type", type),
                    key: type
                  }))
              ]}
              selectedLabelsInit={data?.motorType}
              onChange={(val) => {
                setData({ ...data, motorType: val });
              }}
              disabledLabels={[...groupMotorTypeValues(possibleMotorFiltersValues?.motorType || [])].filter(
                (val) =>
                  ![...groupMotorTypeValues(synchronizedMotorFilters?.type || [])].includes(val) ||
                  !synchronizedMotorFilters
              )}
              changeWithInit
            />

              <SelectionRange
              idLabel="motor-length"
              label={t("msizer.ui.motor_filters.motor_length")}
              min={synchronizedMotorFilters?.length?.min || possibleMotorFiltersValues?.motorLength?.min}
              max={synchronizedMotorFilters?.length?.max || possibleMotorFiltersValues?.motorLength?.max}
              possibleMin={synchronizedMotorFilters?.length?.min || possibleMotorFiltersValues?.motorLength?.min}
              possibleMax={synchronizedMotorFilters?.length?.max || possibleMotorFiltersValues?.motorLength?.max}
              unit={t("msizer.ui.unit.mm")}
              currentMin={data?.motorLength?.min}
              currentMax={data?.motorLength?.max}
              onChange={(min, max) => {
                setData({ ...data, motorLength: { min, max } });
              }}
              changeWithInit
              />
          </div>
          <div className="flex-1 p-2 space-y-4">
            <LabelsPicker
              idLabel="motor-holding-brake"
              label={t("msizer.ui.motor_filters.holding_brake")}
              singleChoice
              required
              error={highlightErrors && (!data?.holdingBrake || data?.holdingBrake?.length === 0)}
              cols={2}
              options={[
                // eslint-disable-next-line max-len
                // loop over all possible holding brakes except null values, and if value is 0 return "Without", and if value is 1 return "With", else return the value
                ...possibleMotorFiltersValues?.holdingBrake
                  .filter((element) => element !== null)
                  .map((hb) => ({
                    // eslint-disable-next-line no-nested-ternary
                    label: tData("motor", "holding_brake", hb === false ? "no" : hb === true ? "yes" : hb),
                    key: hb
                  }))
              ]}
              disabledLabels={possibleMotorFiltersValues?.holdingBrake.filter(
                (val) => !synchronizedMotorFilters?.holdingBrake?.includes(val) || !synchronizedMotorFilters
              )}
              selectedLabelsInit={data?.holdingBrake}
              onChange={(val) => {
                setData({ ...data, holdingBrake: val });
              }}
              changeWithInit
            />

            <LabelsPicker
              idLabel="motor-shaft-end"
              label={t("msizer.ui.motor_filters.shaft_end")}
              singleChoice
              recommended
              cols={2}
              options={[
                // loop over all possible shaft ends except null values
                ...possibleMotorFiltersValues?.shaftEnd
                  .filter((se) => ![null, "SMOOTH_SHAFT", "KEYED", "UNTAPPED", "PARALLEL_KEY"].includes(se))
                  .concat(["keyed", "smooth_shaft"])
                  .map((se) => ({
                    label: tData("motor", "shaft_end", se),
                    key: se
                  }))
              ]}
              selectedLabelsInit={data?.shaftEnd}
              disabledLabels={getDisabledShaftEnd(synchronizedMotorFilters?.shaftEnd || [])}
              onChange={(val) => {
                setData({ ...data, shaftEnd: val });
              }}
              changeWithInit
            />

            <LabelsPicker
              idLabel="motor-feedback"
              label={t("msizer.ui.motor_filters.feedback_type")}
              singleChoice
              cols={2}
              options={[
                // loop through all the possible values except null values
                ...possibleMotorFiltersValues?.motorEncoder
                  .filter(
                    (se) =>
                      ![
                        null,
                        "20_BITS_1_TURN_ABS_ENCODER",
                        "20_BITS_MULTI_TURN_ABS_ENCODER",
                        "SINGLE_TURN_SINCOS_HIPERFACE",
                        "MULTITURN_SINCOS_HIPERFACE",
                        "ABS_MULTITURN_SINCOS_HIPERFACE",
                        "ABS_1_TURN_SINCOS_HIPERFACE",
                        "ABS_SINGLE_TURN_HIPERFACE_DSL",
                        "ABS_MULTITURN_HIPERFACE_DSL",
                        "23_BTS_OPTIC_INCREMENTAL_NCODR",
                        "23_BITS_OPTIC_MULTITURN_ENCDR",
                        "17_BITS_MGNTC_MULTITURN_ENCDR"
                      ].includes(se)
                  )
                  .concat(["single_turn", "multi_turn"])
                  .map((value) => ({
                    label: tData("motor", "feedback_type", value),
                    key: value
                  }))
              ]}
              selectedLabelsInit={data?.motorEncoder}
              onChange={(val) => {
                setData({ ...data, motorEncoder: val });
              }}
              disabledLabels={getDisabledLabels(synchronizedMotorFilters?.feedbackType || [])}
              changeWithInit
            />

            <LabelsPicker
              idLabel="motor-connector"
              label={t("msizer.ui.motor_filters.connector_type")}
              singleChoice
              recommended
              cols={2}
              options={[
                // loop through all the possible values except null values
                ...possibleMotorFiltersValues?.connectorType
                  .filter(
                    (se) =>
                      ![
                        null,
                        "STRAIGHT_CONNECTOR",
                        "STRAIGHT_CONNECTORS",
                        "ROTATABLE_RIGHT-ANGLED_CONNS",
                        "ROTATABLE_RH_ANGLED_CONNECTOR",
                        "CABLE_WITH_STRIPPED_END"
                      ].includes(se)
                  )
                  .concat(["Straight", "Angled", "Free Lead"])
                  ?.sort()
                  .map((value) => ({
                    label: tData("motor", "connector_type", value),
                    key: value
                  }))
              ]}
              selectedLabelsInit={data?.connectorType}
              onChange={(val) => {
                setData({ ...data, connectorType: val });
              }}
              disabledLabels={getDisabledConnectorType(synchronizedMotorFilters?.connectorType || [])}
              changeWithInit
            />
          </div>
        </div>
      </div>
      <div className="flex justify-center space-x-2 pt-2">
        <div className="flex-1 px-2" />
        <div className="flex-1 px-2 flex gap-2 md:gap-0 justify-center">
          <qds-button
            id="select-filters-button-apply"
            {...(!data?.ipDegreeOfProtection ||
              data?.ipDegreeOfProtection?.length === 0 ||
              !data?.holdingBrake ||
              data?.holdingBrake?.length === 0 ? { disabled: "" } : {})}
            onClick={handleApplyFilters}
            text={t("msizer.ui.popup.button.apply")}
          >
          </qds-button>
          <Button onClick={handleClearFilters} border="blue" textColor="blue" large classes="md:hidden">
            {t("msizer.ui.filters.clear")}
          </Button>
        </div>
        <div className="flex-1 px-2" />
      </div>
    </>
  );
};

MotorFilters.propTypes = {
  closeTab: PropTypes.func,
  filterToDisplay: PropTypes.string,
  gearboxFiltersProp: PropTypes.objectOf(PropTypes.any)
};

MotorFilters.defaultProps = {
  closeTab: () => {},
  filterToDisplay: null,
  gearboxFiltersProp: undefined
};

export default MotorFilters;
